import { StatusType } from '@/api/message/message'
import { fetchGrantPlans } from '@/api/grant/grant'
import { ref } from 'vue'
import _ from 'lodash'

interface OptionType {
  label: string
  value: string | number
}

export const planList = ref<any[]>([])

export const statusOptions: OptionType[] = [
  {
    label: '待发送',
    value: StatusType.WaitSend,
  },
  {
    label: '已发送',
    value: StatusType.Send,
  },
  {
    label: '已取消',
    value: StatusType.Cancel,
  },
  {
    label: '已撤回',
    value: StatusType.Revoke,
  },
  {
    label: '生效中',
    value: StatusType.Active,
  },
  {
    label: '停用',
    value: StatusType.Stop,
  },
]

export const popUpOptions: OptionType[] = [
  {
    label: '是',
    value: 1,
  },
  {
    label: '否',
    value: 2,
  },
]

export const typeOptions: OptionType[] = [
  {
    label: '指定时间、对象发送',
    value: 'normal',
  },
  {
    label: '特定时机发送',
    value: 'trigger',
  },
]

export const triggerOptions: OptionType[] = [
  {
    label: '套餐生效时',
    value: 'plan_active',
  },
]

export const getOptionsLabel = (
  value: string,
  options: OptionType[],
): string => {
  const temp = options.find((item) => {
    return item.value === value
  })
  return temp?.label || '-'
}

// 套餐名称
export const getPlanList = async () => {
  const res = await fetchGrantPlans({})

  planList.value = (_.get(res, 'data.data') || []).map((item: any) => ({
    ...item,
    value: item.id,
    label: item.name,
  }))
}
